export { default } from './tag-2'
